import { toast } from "react-toastify";

export const notifyError = (message) => {
    toast.error(message, {
        theme: "colored",
        position: "top-right",
        toastClassName: "custom-toast",
    });
};

export const notifySuccess = (message) => {
    toast.success(message, {
        theme: "colored",
        position: "top-right",
        toastClassName: "custom-toast",
    });
};